import _keyBy from "lodash/keyBy";
import { passthroughWarning } from "../utils/warning";

export const ORDERED_GEOGRAPHIES_PROD = [
  "New York",
  "San Francisco",
  "Toronto",
  "London",
  "Amsterdam",
  "Frankfurt",
  "Singapore",
  "Bangalore",
  "Sydney",
];

export const ORDERED_GEOGRAPHIES_STAGE2 = ["Stage2"];

// TODO Remove this value once continent is added to regions response in getdropletOptions query
const GEOGRAPHIES = [
  {
    geography: "nyc",
    flag: "usa",
    continent: "North America",
  },
  {
    geography: "ams",
    flag: "netherlands",
    continent: "Europe",
  },
  {
    geography: "sfo",
    flag: "usa",
    continent: "North America",
  },
  {
    geography: "sgp",
    flag: "singapore",
    continent: "Asia",
  },
  {
    geography: "lon",
    flag: "uk",
    continent: "Europe",
  },
  {
    geography: "fra",
    flag: "germany",
    continent: "Europe",
  },
  {
    geography: "tor",
    flag: "canada",
    continent: "North America",
  },
  {
    geography: "blr",
    flag: "india",
    continent: "Asia",
  },
  {
    geography: "syd",
    flag: "australia",
    continent: "Australia",
  },
];

export const GEOGRAPHY_MAPPING = passthroughWarning(
  "GEOGRAPHY_MAPPING",
  "locationHelpers.allRegions(...)",
  _keyBy(GEOGRAPHIES, "geography")
);

export type Region = {
  id?: number;
  label: string;
  slug: string;
  flag: string;
  continent: string;
  restriction?: string;
};

export const DEFAULT_REGIONS_PROD = passthroughWarning(`"DEFAULT_REGIONS_PROD"`, `"locationHelpers.allDatacenters(...)"`, [
  {
    label: "New York",
    slug: "nyc1",
    flag: "usa",
    continent: "North America",
  },
  {
    label: "New York",
    slug: "nyc2",
    flag: "usa",
    continent: "North America",
  },
  {
    label: "New York",
    slug: "nyc3",
    flag: "usa",
    continent: "North America",
  },
  {
    label: "San Francisco",
    slug: "sfo1",
    flag: "usa",
    continent: "North America",
  },
  {
    label: "San Francisco",
    slug: "sfo2",
    flag: "usa",
    continent: "North America",
  },
  {
    label: "San Francisco",
    slug: "sfo3",
    flag: "usa",
    continent: "North America",
  },
  {
    label: "Toronto",
    slug: "tor1",
    flag: "canada",
    continent: "North America",
  },
  {
    label: "London",
    slug: "lon1",
    flag: "uk",
    continent: "Europe",
  },
  {
    label: "Amsterdam",
    slug: "ams2",
    flag: "netherlands",
    continent: "Europe",
  },
  {
    label: "Amsterdam",
    slug: "ams3",
    flag: "netherlands",
    continent: "Europe",
  },
  {
    label: "Frankfurt",
    slug: "fra1",
    flag: "germany",
    continent: "Europe",
  },
  {
    label: "Singapore",
    slug: "sgp1",
    flag: "singapore",
    continent: "Asia",
  },
  {
    label: "Bangalore",
    slug: "blr1",
    flag: "india",
    continent: "Asia",
  },
  {
    label: "Sydney",
    slug: "syd1",
    flag: "australia",
    continent: "Australia",
  },
] as Region[]);

export const DEFAULT_REGIONS_STAGE2 = passthroughWarning("DEFAULT_REGIONS_STAGE2", "locationHelpers.allStage2Datacenters(...)", [
  {
    label: "Stage2",
    slug: "s2r1",
    flag: "usa",
    continent: "North America",
  },
  {
    label: "Stage2",
    slug: "s2r2",
    flag: "usa",
    continent: "North America",
  },
  {
    label: "Stage2",
    slug: "s2r3",
    flag: "usa",
    continent: "North America",
  },
  {
    label: "Stage2",
    slug: "s2r4",
    flag: "usa",
    continent: "North America",
  },
  {
    label: "Stage2",
    slug: "s2r5",
    flag: "usa",
    continent: "North America",
  },
  {
    label: "Stage2",
    slug: "s2r6",
    flag: "usa",
    continent: "North America",
  },
  {
    label: "Stage2",
    slug: "s2r7",
    flag: "usa",
    continent: "North America",
  },
  {
    label: "Stage2",
    slug: "s2r8",
    flag: "usa",
    continent: "North America",
  },
] as Region[]);
